import { MyTasksPage } from "./my-tasks.page";

export const myTasksRoutes = [
  {
    path: "my-tasks",
    element: <MyTasksPage />,
  },
];
